import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 1.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0V2A.75.75 0 0 1 6 1.25m12 0a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75M7 13a1 1 0 0 1 1-1h.009a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m3.996 0a1 1 0 0 1 1-1h.008a1 1 0 1 1 0 2h-.008a1 1 0 0 1-1-1m3.995 0a1 1 0 0 1 1-1H16a1 1 0 1 1 0 2h-.009a1 1 0 0 1-1-1M7 17a1 1 0 0 1 1-1h.009a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m3.996 0a1 1 0 0 1 1-1h.008a1 1 0 1 1 0 2h-.008a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.5 8h17"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.99 2.25h2.02c1.965 0 3.52 0 4.739.177 1.258.183 2.264.568 3.05 1.417.777.841 1.123 1.904 1.289 3.236.162 1.304.162 2.976.162 5.11v.62c0 2.133 0 3.806-.162 5.11-.166 1.332-.512 2.395-1.29 3.236-.785.849-1.79 1.234-3.05 1.417-1.217.177-2.774.177-4.737.177h-2.022c-1.963 0-3.52 0-4.738-.177-1.258-.183-2.264-.568-3.05-1.417-.777-.841-1.123-1.904-1.289-3.235-.162-1.305-.162-2.977-.162-5.111v-.62c0-2.133 0-3.806.162-5.11.166-1.332.512-2.395 1.29-3.236.785-.849 1.79-1.234 3.05-1.417 1.217-.177 2.774-.177 4.737-.177M6.466 3.911c-1.07.156-1.698.448-2.164.952-.475.513-.755 1.216-.902 2.402-.15 1.201-.151 2.78-.151 4.978v.514c0 2.198.001 3.777.15 4.978.148 1.186.428 1.89.903 2.402.466.504 1.094.796 2.164.952 1.098.16 2.545.161 4.583.161h1.9c2.038 0 3.485-.002 4.583-.161 1.07-.156 1.698-.448 2.164-.952.475-.513.755-1.216.902-2.402.15-1.201.151-2.78.151-4.978v-.514c0-2.198-.001-3.777-.15-4.978-.148-1.186-.428-1.89-.903-2.402-.466-.504-1.094-.796-2.164-.952-1.098-.16-2.545-.161-4.583-.161h-1.9c-2.038 0-3.485.002-4.583.161",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.25 8A.75.75 0 0 1 3 7.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 8",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }